module.exports = __webpack_public_path__ + "static/assets/c239a514615eea2c09570fb5f037992a.svg";